import { setAPIError } from 'redux/actions';

export const handleApiError = async () => {
  const { store } = await import('App');

  store.dispatch(setAPIError(true));
};
